import { render, staticRenderFns } from "./ImsSpreadModal.vue?vue&type=template&id=80a4eb7a&"
import script from "./ImsSpreadModal.vue?vue&type=script&lang=js&"
export * from "./ImsSpreadModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports